import { LanguageProps } from '@/types/translate/props';

export const languageList: LanguageProps[] = [
  {
    id: 1,
    name: 'Portuguese',
    lang: 'pt',
    image: 'br.svg',
  },
  {
    id: 2,
    name: 'English',
    lang: 'en',
    image: 'us.svg',
  },
  {
    id: 3,
    name: 'Spanish',
    lang: 'es',
    image: 'es.svg',
  },
  {
    id: 4,
    name: 'French',
    lang: 'fr',
    image: 'fr.svg',
  },
  {
    id: 5,
    name: 'German',
    lang: 'de',
    image: 'de.svg',
  },
  {
    id: 6,
    name: 'Russian',
    lang: 'ru',
    image: 'ru.svg',
  },
  {
    id: 7,
    name: 'China',
    lang: 'zh',
    image: 'cn.svg',
  },
  {
    id: 8,
    name: 'Indonesia',
    lang: 'id',
    image: 'id.svg',
  },
  {
    id: 9,
    name: 'Hindi',
    lang: 'hi',
    image: 'in.svg',
  },
  {
    id: 10,
    name: 'Italian',
    lang: 'it',
    image: 'it.svg',
  },
];
